import ProductVariantDisplay from './productVariantDisplay';

export default ProductVariantDisplay;
